module.exports = __webpack_public_path__ + "static/media/certificado.91ff2ea0.png";